import { AppLocale } from './config';
import type { SxProps, Theme } from '@mui/material/styles';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getDayjsLocale } from './formatting';

dayjs.extend(customParseFormat);

export const BIRTH_DATE_FORMAT: Record<AppLocale, string> = {
  'pt-BR': 'DD/MM/YYYY',
  'pt-PT': 'DD/MM/YYYY',
  'es-419': 'DD/MM/YYYY',
  'en-US': 'MM/DD/YYYY',
};

export const getBirthDateFormat = (locale: AppLocale) => BIRTH_DATE_FORMAT[locale];

export const getBirthDateDayOfWeekFormatter = (locale: AppLocale) => (date: Dayjs) => {
  const label = date.locale(getDayjsLocale(locale)).format('ddd').replace('.', '');
  return label.charAt(0).toUpperCase() + label.slice(1, 3);
};

/**
 * Keeps the calendar grid independent from global layout rules applied by
 * the application or Bootstrap. Each week must remain a separate row.
 */
export const birthDatePickerCalendarSx: SxProps<Theme> = {
  '& .MuiDateCalendar-root, & .MuiDayCalendar-root': {
    width: 320,
    minWidth: 320,
  },
  '& .MuiDayCalendar-monthContainer': {
    display: 'block',
    overflow: 'visible',
  },
  '& .MuiDayCalendar-slideTransition': {
    width: '100%',
    overflow: 'visible',
  },
  '& .MuiDayCalendar-header, & .MuiDayCalendar-weekContainer': {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 40px)',
    justifyContent: 'center',
    justifyItems: 'center',
    width: '100%',
  },
  '& .MuiDayCalendar-weekDayLabel, & .MuiPickersDay-root': {
    width: 36,
    height: 36,
    margin: '0 auto',
  },
};

export const formatBirthDate = (value: string, locale: AppLocale): string => {
  const date = dayjs(value, 'YYYY-MM-DD', true);
  return date.isValid() ? date.format(getBirthDateFormat(locale)) : '';
};
